(function () {
  "use strict";

  /* ---------- language ---------- */
  function isEnglishLanguage() {
    return (
      (document.documentElement.lang || "")
        .toLowerCase()
        .indexOf("en") === 0
    );
  }

  /* ---------- toast ---------- */
  var toastEl = document.getElementById("toast");
  var toastTimer;

  function showToast(msg) {
    if (!toastEl) return;

    toastEl.textContent = msg;
    toastEl.classList.add("show");

    clearTimeout(toastTimer);

    toastTimer = setTimeout(function () {
      toastEl.classList.remove("show");
    }, 2600);
  }

  /* ---------- mobile nav ---------- */
  var burgerBtn = document.getElementById("burgerBtn");
  var mobileNav = document.getElementById("mobileNav");

  if (burgerBtn && mobileNav) {
    burgerBtn.addEventListener("click", function () {
      mobileNav.classList.toggle("open");
    });

    mobileNav.querySelectorAll("a").forEach(function (a) {
      a.addEventListener("click", function () {
        mobileNav.classList.remove("open");
      });
    });
  }

  /* ---------- FAQ accordion ---------- */
  document.querySelectorAll(".faq-item").forEach(function (item) {
    var btn = item.querySelector(".faq-q");
    var answer = item.querySelector(".faq-a");

    if (!btn) return;

    btn.addEventListener("click", function () {
      var isOpen = item.classList.contains("open");

      document.querySelectorAll(".faq-item.open").forEach(function (openItem) {
        openItem.classList.remove("open");

        var openAnswer = openItem.querySelector(".faq-a");

        if (openAnswer) {
          openAnswer.style.maxHeight = null;
        }
      });

      if (!isOpen) {
        item.classList.add("open");

        if (answer) {
          answer.style.maxHeight = answer.scrollHeight + "px";
        }
      }
    });
  });

  /* ---------- count-up stats ---------- */
  var counters = document.querySelectorAll("[data-count]");

  if (counters.length) {
    var counterObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          var target = parseFloat(el.dataset.count);
          var decimals = parseInt(el.dataset.decimal || "0", 10);
          var duration = 1400;
          var start = performance.now();

          function tick(now) {
            var progress = Math.min((now - start) / duration, 1);
            var value = target * progress;

            el.textContent = decimals
              ? value.toFixed(decimals)
              : Math.floor(value);

            if (progress < 1) {
              requestAnimationFrame(tick);
            } else {
              el.textContent = decimals
                ? target.toFixed(decimals)
                : target;
            }
          }

          requestAnimationFrame(tick);
          counterObserver.unobserve(el);
        }
      });
    }, { threshold: 0.4 });

    counters.forEach(function (counter) {
      counterObserver.observe(counter);
    });
  }

  /* ---------- cart ---------- */
  var cartBtn = document.getElementById("cartBtn");
  var cartClose = document.getElementById("cartClose");
  var cartDrawer = document.getElementById("cartDrawer");
  var cartBackdrop = document.getElementById("cartBackdrop");
  var cartItemsEl = document.getElementById("cartItems");
  var cartEmptyMsg = document.getElementById("cartEmptyMsg");
  var cartSubtotalEl = document.getElementById("cartSubtotal");
  var cartCountEl = document.getElementById("cartCount");

  function openCart() {
    if (!cartDrawer) return;

    cartDrawer.classList.add("open");

    if (cartBackdrop) {
      cartBackdrop.classList.add("open");
    }
  }

  function closeCart() {
    if (!cartDrawer) return;

    cartDrawer.classList.remove("open");

    if (cartBackdrop) {
      cartBackdrop.classList.remove("open");
    }
  }

  if (cartBtn) {
    cartBtn.addEventListener("click", function () {
      openCart();
      refreshCart();
    });
  }

  if (cartClose) {
    cartClose.addEventListener("click", closeCart);
  }

  if (cartBackdrop) {
    cartBackdrop.addEventListener("click", closeCart);
  }

  function moneyFormat(cents) {
    return (cents / 100).toFixed(2).replace(".", ",") + " €";
  }

  function renderCart(cart) {
    if (!cartItemsEl) return;

    var english = isEnglishLanguage();

    var removeText = english
      ? "Remove"
      : "Entfernen";

    var emptyText = english
      ? "Your shopping cart is empty."
      : "Dein Warenkorb ist noch leer.";

    cartItemsEl.querySelectorAll(".cart-item").forEach(function (el) {
      el.remove();
    });

    if (!cart.items || cart.items.length === 0) {
      if (cartEmptyMsg) {
        cartEmptyMsg.style.display = "block";
        cartEmptyMsg.textContent = emptyText;
      }
    } else {
      if (cartEmptyMsg) {
        cartEmptyMsg.style.display = "none";
      }

      cart.items.forEach(function (item) {
        var row = document.createElement("div");

        row.className = "cart-item";

        row.innerHTML =
          '<img src="' +
          (item.image || "") +
          '" alt="">' +
          '<div class="ci-info">' +
          "<h5>" +
          (item.vendor || "") +
          " — " +
          item.product_title +
          "</h5>" +
          "<span>" +
          (item.variant_title || "") +
          " · " +
          moneyFormat(item.price) +
          "</span>" +
          '<div class="cart-qty">' +
          '<button data-action="dec" data-key="' +
          item.key +
          '" data-qty="' +
          item.quantity +
          '">−</button>' +
          "<span>" +
          item.quantity +
          "</span>" +
          '<button data-action="inc" data-key="' +
          item.key +
          '" data-qty="' +
          item.quantity +
          '">+</button>' +
          "</div>" +
          '<button class="cart-remove" data-action="remove" data-key="' +
          item.key +
          '">' +
          removeText +
          "</button>" +
          "</div>";

        cartItemsEl.appendChild(row);
      });
    }

    if (cartSubtotalEl) {
      cartSubtotalEl.textContent = moneyFormat(cart.total_price);
    }

    if (cartCountEl) {
      if (cart.item_count > 0) {
        cartCountEl.hidden = false;
        cartCountEl.textContent = cart.item_count;
      } else {
        cartCountEl.hidden = true;
      }
    }
  }

  function refreshCart() {
    fetch("/cart.js")
      .then(function (response) {
        return response.json();
      })
      .then(renderCart)
      .catch(function () {});
  }

  function addToCart(variantId, qty) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: qty || 1
          }
        ]
      })
    }).then(function (response) {
      if (!response.ok) {
        return response.json().then(function (error) {
          throw new Error(
            error.description ||
            (
              isEnglishLanguage()
                ? "Could not add this item."
                : "Konnte nicht hinzugefügt werden"
            )
          );
        });
      }

      return response.json();
    });
  }

  function changeCartLine(key, quantity) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify({
        id: key,
        quantity: quantity
      })
    }).then(function (response) {
      return response.json();
    });
  }

  if (cartItemsEl) {
    cartItemsEl.addEventListener("click", function (event) {
      var btn = event.target.closest("button[data-action]");

      if (!btn) return;

      var key = btn.dataset.key;
      var qty = parseInt(btn.dataset.qty, 10) || 1;
      var action = btn.dataset.action;

      var newQty =
        action === "inc"
          ? qty + 1
          : action === "dec"
            ? Math.max(0, qty - 1)
            : 0;

      changeCartLine(key, newQty).then(renderCart);
    });
  }

  var checkoutBtn = document.getElementById("checkoutBtn");

  if (checkoutBtn) {
    checkoutBtn.addEventListener("click", function () {
      window.location.href = "/checkout";
    });
  }

  /* ---------- quick add to cart ---------- */
  document.body.addEventListener("click", function (event) {
    var addBtn = event.target.closest(".add[data-variant-id]");

    if (!addBtn || addBtn.disabled) return;

    event.preventDefault();

    var variantId = addBtn.dataset.variantId;
    var english = isEnglishLanguage();
    var originalText = addBtn.textContent;

    addBtn.textContent = "...";

    addToCart(variantId, 1)
      .then(function () {
        addBtn.textContent = english
          ? "Added ✓"
          : "Hinzugefügt ✓";

        showToast(
          english
            ? "Added to cart"
            : "Zum Warenkorb hinzugefügt"
        );

        refreshCart();
        openCart();

        setTimeout(function () {
          addBtn.textContent = originalText;
        }, 1200);
      })
      .catch(function (error) {
        addBtn.textContent = originalText;

        showToast(
          error.message ||
          (
            english
              ? "Something went wrong."
              : "Das hat leider nicht geklappt."
          )
        );
      });
  });

  /* ---------- product page ---------- */
  var pdpForm = document.getElementById("pdpForm");

  if (pdpForm) {
    var variantInput = document.getElementById("pdpVariantId");
    var priceEl = document.getElementById("pdpPrice");
    var pdpAddBtn = document.getElementById("pdpAddBtn");

    document.querySelectorAll("#pdpSizeOptions .qv-size-pill").forEach(function (pill) {
      pill.addEventListener("click", function () {
        if (pill.dataset.available === "false") {
          showToast(
            isEnglishLanguage()
              ? "This size is sold out."
              : "Diese Größe ist ausverkauft."
          );

          return;
        }

        document
          .querySelectorAll("#pdpSizeOptions .qv-size-pill")
          .forEach(function (otherPill) {
            otherPill.classList.remove("active");
          });

        pill.classList.add("active");

        if (variantInput) {
          variantInput.value = pill.dataset.variantId;
        }

        if (priceEl) {
          priceEl.textContent = pill.dataset.price;
        }
      });
    });

    pdpForm.addEventListener("submit", function (event) {
      event.preventDefault();

      if (pdpAddBtn && pdpAddBtn.disabled) return;

      addToCart(variantInput.value, 1)
        .then(function () {
          showToast(
            isEnglishLanguage()
              ? "Added to cart"
              : "Zum Warenkorb hinzugefügt"
          );

          refreshCart();
          openCart();
        })
        .catch(function (error) {
          showToast(
            error.message ||
            (
              isEnglishLanguage()
                ? "Something went wrong."
                : "Das hat leider nicht geklappt."
            )
          );
        });
    });

    document.querySelectorAll(".qv-thumb[data-full]").forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        var mainImg = document.getElementById("pdpMainImg");

        if (mainImg) {
          mainImg.src = thumb.dataset.full;
        }

        document.querySelectorAll(".qv-thumb").forEach(function (otherThumb) {
          otherThumb.classList.remove("active");
        });

        thumb.classList.add("active");
      });
    });

  }

  /* ---------- delivery tracker (product page + quick view) ---------- */
  function prefersReducedMotion() {
    return !!(
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches
    );
  }

  function shortDate(offsetDays) {
    var weekdays = isEnglishLanguage()
      ? ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]
      : ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"];

    var date = new Date();

    date.setDate(date.getDate() + offsetDays);

    return weekdays[date.getDay()] +
      ", " +
      date.getDate() +
      "." +
      (date.getMonth() + 1) +
      ".";
  }

  var trackerObserver = "IntersectionObserver" in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-animated");
            trackerObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.6 })
    : null;

  function initTrackers(root) {
    (root || document).querySelectorAll("[data-tracker]").forEach(function (tracker) {
      tracker.querySelectorAll("[data-tracker-date]").forEach(function (el) {
        var offset = parseInt(el.dataset.trackerDate, 10) || 0;

        el.textContent = offset === 0
          ? (isEnglishLanguage() ? "Today" : "Heute")
          : shortDate(offset);
      });

      if (trackerObserver && !prefersReducedMotion()) {
        tracker.classList.add("is-ready");
        trackerObserver.observe(tracker);
      }
    });
  }

  initTrackers(document);

  /* ---------- quick view ---------- */
  var qvOverlay = null;
  var qvDialog = null;
  var qvBody = null;
  var qvLastFocus = null;
  var qvGallery = null;
  var qvCloseTimer;

  function qvIsOpen() {
    return !!(qvOverlay && qvOverlay.classList.contains("open"));
  }

  function buildQuickViewShell() {
    if (qvOverlay) return;

    qvOverlay = document.createElement("div");
    qvOverlay.className = "qv-overlay";
    qvOverlay.hidden = true;

    qvOverlay.innerHTML =
      '<div class="qv-dialog" role="dialog" aria-modal="true" tabindex="-1">' +
        '<button type="button" class="qv-close" data-qv-close>' +
          '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">' +
            '<line x1="5" y1="5" x2="19" y2="19"/><line x1="19" y1="5" x2="5" y2="19"/>' +
          "</svg>" +
        "</button>" +
        '<div class="qv-body" data-qv-body></div>' +
      "</div>";

    document.body.appendChild(qvOverlay);

    qvDialog = qvOverlay.querySelector(".qv-dialog");
    qvBody = qvOverlay.querySelector("[data-qv-body]");

    qvOverlay.addEventListener("click", function (event) {
      if (
        event.target === qvOverlay ||
        event.target.closest("[data-qv-close]")
      ) {
        closeQuickView();
      }
    });

    qvOverlay.addEventListener("keydown", trapQuickViewFocus);
  }

  function lockPageScroll() {
    var scrollbar = window.innerWidth - document.documentElement.clientWidth;

    document.documentElement.classList.add("qv-locked");

    if (scrollbar > 0) {
      document.body.style.paddingRight = scrollbar + "px";
    }
  }

  function unlockPageScroll() {
    document.documentElement.classList.remove("qv-locked");
    document.body.style.paddingRight = "";
  }

  /* quick view data comes inline with each card (script[data-qv-data]) - no request on click */
  var QV_SIZES = "(max-width: 749px) 100vw, 520px";
  var qvDataCache = typeof WeakMap === "function" ? new WeakMap() : null;

  function escapeHtml(value) {
    return String(value == null ? "" : value).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function imageAtWidth(url, width) {
    if (/[?&]width=\d+/.test(url)) {
      return url.replace(/([?&])width=\d+/, "$1width=" + width);
    }

    return url + (url.indexOf("?") === -1 ? "?" : "&") + "width=" + width;
  }

  function imageSrcset(url) {
    return [700, 1000, 1400].map(function (width) {
      return imageAtWidth(url, width) + " " + width + "w";
    }).join(", ");
  }

  function readQuickViewData(card) {
    if (qvDataCache && qvDataCache.has(card)) {
      return qvDataCache.get(card);
    }

    var script = card.querySelector("script[data-qv-data]");

    if (!script) return null;

    var data = JSON.parse(script.textContent);

    if (!data || !data.url || !data.variants || !data.variants.length) return null;

    if (qvDataCache) {
      qvDataCache.set(card, data);
    }

    return data;
  }

  /* on first hover/focus/touch: warm the browser cache for the gallery images */
  function preloadQuickViewImages(card) {
    if (!card || card.dataset.qvPreloaded) return;

    card.dataset.qvPreloaded = "1";

    var data;

    try {
      data = readQuickViewData(card);
    } catch (error) {
      return;
    }

    if (!data || !data.images) return;

    data.images.forEach(function (image, index) {
      var img = new Image();

      img.decoding = "async";
      img.sizes = QV_SIZES;
      img.srcset = imageSrcset(image.src);
      img.src = index === 0 ? image.src : imageAtWidth(image.src, 1000);
    });
  }

  function buildQuickViewHtml(data) {
    var english = isEnglishLanguage();
    var images = data.images || [];
    var count = images.length;
    var selected = data.variants.filter(function (variant) {
      return String(variant.id) === String(data.selected);
    })[0] || data.variants[0];

    function t(en, de) {
      return english ? en : de;
    }

    function dims(image) {
      return image.w && image.h
        ? ' width="' + escapeHtml(image.w) + '" height="' + escapeHtml(image.h) + '"'
        : "";
    }

    var html = '<div class="qv-layout" data-quick-view>' +
      '<div class="qv-gallery" data-qv-gallery>' +
      '<div class="qv-track" data-qv-track>';

    if (!count) {
      html += '<div class="qv-slide"><img src="' + escapeHtml(data.ph || "") + '" alt="" draggable="false"></div>';
    }

    images.forEach(function (image, index) {
      html += '<div class="qv-slide" role="group" aria-roledescription="' + t("slide", "Bild") +
        '" aria-label="' + (index + 1) + " / " + count + '">';

      if (index === 0) {
        /* same URL as the card image -> already in the browser cache */
        html += '<img src="' + escapeHtml(image.src) + '" data-srcset="' + escapeHtml(imageSrcset(image.src)) +
          '" sizes="' + QV_SIZES + '" alt="' + escapeHtml(image.alt) + '"' + dims(image) +
          ' draggable="false" fetchpriority="high" decoding="async">';
      } else {
        html += '<img src="' + escapeHtml(imageAtWidth(image.src, 1000)) + '" srcset="' + escapeHtml(imageSrcset(image.src)) +
          '" sizes="' + QV_SIZES + '" alt="' + escapeHtml(image.alt) + '"' + dims(image) +
          ' draggable="false" loading="lazy" decoding="async">';
      }

      html += "</div>";
    });

    html += "</div>";

    if (count > 1) {
      html += '<span class="qv-counter" data-qv-counter aria-hidden="true">1 / ' + count + "</span>" +
        '<button type="button" class="qv-arrow qv-prev" data-qv-prev aria-label="' + t("Previous image", "Vorheriges Bild") + '" disabled>' +
          '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M15 5l-7 7 7 7"/></svg>' +
        "</button>" +
        '<button type="button" class="qv-arrow qv-next" data-qv-next aria-label="' + t("Next image", "Nächstes Bild") + '">' +
          '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M9 5l7 7-7 7"/></svg>' +
        "</button>" +
        '<div class="qv-dots">';

      images.forEach(function (image, index) {
        html += '<button type="button" class="qv-dot' + (index === 0 ? " active" : "") + '" data-qv-dot aria-label="' +
          t("Show image " + (index + 1), "Bild " + (index + 1) + " anzeigen") + '" aria-current="' + (index === 0 ? "true" : "false") + '"></button>';
      });

      html += "</div>";
    }

    html += "</div>" +
      '<div class="qv-info">' +
        '<span class="brand">' + escapeHtml(data.vendor) + "</span>" +
        '<h2 class="qv-title" id="QuickViewTitle-' + escapeHtml(data.id) + '" data-qv-title>' + escapeHtml(data.title) + "</h2>" +
        '<div class="price qv-price"><span data-qv-price>' + escapeHtml(selected.p) + "</span>" +
          '<s class="qv-compare" data-qv-compare' + (selected.c ? "" : " hidden") + ">" + escapeHtml(selected.c || "") + "</s>" +
        "</div>" +
        '<form method="post" action="/cart/add" class="qv-form" accept-charset="UTF-8">' +
          '<input type="hidden" name="form_type" value="product">' +
          '<input type="hidden" name="id" value="' + escapeHtml(selected.id) + '" data-qv-variant>' +
          '<div class="qv-size-label">' + t("Size", "Größe") + "</div>";

    if (data.single) {
      html += '<div class="qv-size-pill active">' +
        (selected.t && selected.t !== "Default Title" ? escapeHtml(selected.t) : t("One Size", "Einheitsgröße")) +
        "</div>";
    } else {
      html += '<div class="qv-size-options">';

      data.variants.forEach(function (variant) {
        var isSelected = variant === selected;

        html += '<button type="button" class="qv-size-pill' + (isSelected ? " active" : "") + (variant.a ? "" : " qv-size-unavailable") +
          '" data-variant-id="' + escapeHtml(variant.id) + '" data-available="' + (variant.a ? "true" : "false") +
          '" data-price="' + escapeHtml(variant.p) + '" data-compare="' + escapeHtml(variant.c || "") +
          '" aria-pressed="' + (isSelected ? "true" : "false") + '">' + escapeHtml(variant.t) + "</button>";
      });

      html += "</div>";
    }

    html += '<button type="submit" class="btn qv-add" data-qv-add' + (selected.a ? "" : " disabled") + ">" +
          (selected.a ? t("Add to cart", "In den Warenkorb") : t("Sold out", "Ausverkauft")) +
        "</button>" +
        "</form>" +
        "<div data-qv-tracker-slot></div>" +
        (data.excerpt ? '<p class="qv-excerpt">' + escapeHtml(data.excerpt) + "</p>" : "") +
        '<a class="qv-details-link" href="' + escapeHtml(data.url) + '">' + t("View all details", "Alle Details ansehen") + " &rarr;</a>" +
      "</div>" +
    "</div>";

    return html;
  }

  /* first image comes from the card (browser cache); sharper sizes after it is shown */
  function upgradeFirstImage(root) {
    var img = root.querySelector("img[data-srcset]");

    if (!img) return;

    function apply() {
      setTimeout(function () {
        if (!img.dataset.srcset) return;

        img.srcset = img.dataset.srcset;
        img.removeAttribute("data-srcset");
      }, 300);
    }

    if (img.complete) {
      apply();
    } else {
      img.addEventListener("load", apply, { once: true });
    }
  }

  /* returns false when there is no usable data -> caller lets the link navigate */
  function openQuickView(card, trigger) {
    var data = readQuickViewData(card);

    if (!data) return false;

    var html = buildQuickViewHtml(data);

    buildQuickViewShell();
    clearTimeout(qvCloseTimer);

    qvLastFocus = trigger || document.activeElement;
    qvGallery = null;

    qvDialog.querySelector(".qv-close").setAttribute(
      "aria-label",
      isEnglishLanguage() ? "Close quick view" : "Schnellansicht schließen"
    );

    qvBody.innerHTML = html;

    var root = qvBody.querySelector("[data-quick-view]");
    var slot = root.querySelector("[data-qv-tracker-slot]");
    var trackerTemplate = document.getElementById("QuickViewTracker");

    if (slot && trackerTemplate && trackerTemplate.content) {
      slot.replaceWith(trackerTemplate.content.cloneNode(true));
    } else if (slot) {
      slot.remove();
    }

    qvDialog.removeAttribute("aria-label");
    qvDialog.removeAttribute("aria-busy");
    qvDialog.setAttribute("aria-labelledby", root.querySelector("[data-qv-title]").id);

    qvOverlay.hidden = false;
    lockPageScroll();
    qvBody.scrollTop = 0;

    initQuickView(root);
    initTrackers(root);
    upgradeFirstImage(root);

    root.querySelectorAll('.qv-slide img[loading="lazy"]').forEach(function (img) {
      function shown() {
        img.classList.add("is-loaded");
      }

      if (img.complete && img.naturalWidth > 0) {
        shown();
      } else {
        img.addEventListener("load", shown, { once: true });
        img.addEventListener("error", shown, { once: true });
      }
    });

    requestAnimationFrame(function () {
      qvOverlay.classList.add("open");
    });

    qvDialog.querySelector(".qv-close").focus();

    return true;
  }

  var qvHoverCard = null;
  var qvHoverTimer;

  document.addEventListener("mouseover", function (event) {
    var card = event.target.closest ? event.target.closest("[data-quick-view-url]") : null;

    if (card === qvHoverCard) return;

    qvHoverCard = card;
    clearTimeout(qvHoverTimer);

    if (!card) return;

    qvHoverTimer = setTimeout(function () {
      preloadQuickViewImages(card);
    }, 80);
  });

  document.addEventListener("focusin", function (event) {
    preloadQuickViewImages(event.target.closest ? event.target.closest("[data-quick-view-url]") : null);
  });

  document.addEventListener("touchstart", function (event) {
    preloadQuickViewImages(event.target.closest ? event.target.closest("[data-quick-view-url]") : null);
  }, { passive: true });

  function closeQuickView() {
    if (!qvIsOpen()) return;

    qvGallery = null;
    qvOverlay.classList.remove("open");
    unlockPageScroll();

    qvCloseTimer = setTimeout(function () {
      qvOverlay.hidden = true;
      qvBody.innerHTML = "";
    }, prefersReducedMotion() ? 120 : 180);

    if (qvLastFocus && document.body.contains(qvLastFocus)) {
      qvLastFocus.focus();
    }
  }

  function trapQuickViewFocus(event) {
    if (event.key !== "Tab") return;

    var focusable = Array.prototype.filter.call(
      qvDialog.querySelectorAll(
        'a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])'
      ),
      function (el) {
        return el.offsetParent !== null;
      }
    );

    if (!focusable.length) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (
      event.shiftKey &&
      (document.activeElement === first || document.activeElement === qvDialog)
    ) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function initQuickViewGallery(gallery) {
    if (!gallery) return null;

    var track = gallery.querySelector("[data-qv-track]");
    var count = track ? track.children.length : 0;

    if (!count) return null;

    var prevBtn = gallery.querySelector("[data-qv-prev]");
    var nextBtn = gallery.querySelector("[data-qv-next]");
    var counter = gallery.querySelector("[data-qv-counter]");
    var dots = gallery.querySelectorAll("[data-qv-dot]");
    var index = 0;
    var scrollTimer;
    var wheelTime = 0;
    var drag = null;

    function update(i) {
      index = i;

      if (counter) {
        counter.textContent = (i + 1) + " / " + count;
      }

      dots.forEach(function (dot, n) {
        dot.classList.toggle("active", n === i);
        dot.setAttribute("aria-current", n === i ? "true" : "false");
      });

      if (prevBtn) prevBtn.disabled = i === 0;
      if (nextBtn) nextBtn.disabled = i === count - 1;
    }

    function goTo(i, instant) {
      var target = Math.max(0, Math.min(count - 1, i));

      track.scrollTo({
        left: target * track.clientWidth,
        behavior: instant || prefersReducedMotion() ? "auto" : "smooth"
      });

      update(target);
    }

    track.addEventListener("scroll", function () {
      if (drag) return;

      clearTimeout(scrollTimer);

      scrollTimer = setTimeout(function () {
        update(Math.round(track.scrollLeft / track.clientWidth));
      }, 60);
    }, { passive: true });

    if (prevBtn) {
      prevBtn.addEventListener("click", function () {
        goTo(index - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener("click", function () {
        goTo(index + 1);
      });
    }

    dots.forEach(function (dot, n) {
      dot.addEventListener("click", function () {
        goTo(n);
      });
    });

    /* vertical mouse wheel switches images; horizontal trackpad scroll stays native */
    track.addEventListener("wheel", function (event) {
      if (count < 2 || Math.abs(event.deltaX) >= Math.abs(event.deltaY)) return;

      var direction = event.deltaY > 0 ? 1 : -1;

      if (
        (direction < 0 && index === 0) ||
        (direction > 0 && index === count - 1)
      ) {
        return;
      }

      event.preventDefault();

      var now = Date.now();

      if (now - wheelTime < 450 || Math.abs(event.deltaY) < 4) return;

      wheelTime = now;
      goTo(index + direction);
    }, { passive: false });

    /* mouse drag; touch swipe uses native scroll snapping */
    track.addEventListener("pointerdown", function (event) {
      if (event.pointerType !== "mouse" || event.button !== 0 || count < 2) return;

      drag = {
        x: event.clientX,
        left: track.scrollLeft,
        start: Math.round(track.scrollLeft / track.clientWidth)
      };

      track.setPointerCapture(event.pointerId);
      track.classList.add("is-dragging");
    });

    track.addEventListener("pointermove", function (event) {
      if (!drag) return;

      track.scrollLeft = drag.left - (event.clientX - drag.x);
    });

    function endDrag(event) {
      if (!drag) return;

      var dx = event.clientX - drag.x;
      var target = drag.start;

      if (Math.abs(dx) > track.clientWidth * 0.12) {
        target = drag.start + (dx < 0 ? 1 : -1);
      }

      drag = null;
      goTo(target);

      setTimeout(function () {
        track.classList.remove("is-dragging");
      }, 450);
    }

    track.addEventListener("pointerup", endDrag);
    track.addEventListener("pointercancel", endDrag);

    update(0);

    return {
      step: function (direction) {
        goTo(index + direction);
      },
      refresh: function () {
        goTo(index, true);
      }
    };
  }

  function initQuickView(root) {
    qvGallery = initQuickViewGallery(root.querySelector("[data-qv-gallery]"));

    var form = root.querySelector(".qv-form");
    var variantInput = root.querySelector("[data-qv-variant]");
    var priceEl = root.querySelector("[data-qv-price]");
    var compareEl = root.querySelector("[data-qv-compare]");
    var addBtn = root.querySelector("[data-qv-add]");
    var pills = root.querySelectorAll(".qv-size-pill[data-variant-id]");

    pills.forEach(function (pill) {
      pill.addEventListener("click", function () {
        if (pill.dataset.available === "false") {
          showToast(
            isEnglishLanguage()
              ? "This size is sold out."
              : "Diese Größe ist ausverkauft."
          );

          return;
        }

        pills.forEach(function (otherPill) {
          otherPill.classList.remove("active");
          otherPill.setAttribute("aria-pressed", "false");
        });

        pill.classList.add("active");
        pill.setAttribute("aria-pressed", "true");

        if (variantInput) {
          variantInput.value = pill.dataset.variantId;
        }

        if (priceEl) {
          priceEl.textContent = pill.dataset.price;
        }

        if (compareEl) {
          compareEl.textContent = pill.dataset.compare || "";
          compareEl.hidden = !pill.dataset.compare;
        }
      });
    });

    if (!form || !variantInput) return;

    form.addEventListener("submit", function (event) {
      event.preventDefault();

      if (!addBtn || addBtn.disabled) return;

      var english = isEnglishLanguage();
      var originalText = addBtn.textContent;

      addBtn.disabled = true;
      addBtn.textContent = "...";

      addToCart(variantInput.value, 1)
        .then(function () {
          showToast(
            english
              ? "Added to cart"
              : "Zum Warenkorb hinzugefügt"
          );

          closeQuickView();
          refreshCart();
          openCart();
        })
        .catch(function (error) {
          showToast(
            error.message ||
            (
              english
                ? "Something went wrong."
                : "Das hat leider nicht geklappt."
            )
          );
        })
        .then(function () {
          addBtn.disabled = false;
          addBtn.textContent = originalText;
        });
    });
  }

  document.addEventListener("click", function (event) {
    if (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    ) {
      return;
    }

    var link = event.target.closest("[data-quick-view-link]");

    if (!link) return;

    var card = link.closest("[data-quick-view-url]");

    if (!card) return;

    var opened = false;

    try {
      opened = openQuickView(card, link);
    } catch (error) {
      opened = false;

      if (qvIsOpen()) {
        closeQuickView();
      }
    }

    /* no data or an error: the normal link to the product page stays as fallback */
    if (opened) {
      event.preventDefault();
    }
  });

  if (document.querySelector("[data-quick-view-url]")) {
    (window.requestIdleCallback || setTimeout)(buildQuickViewShell);
  }

  window.addEventListener("resize", function () {
    if (qvGallery) {
      qvGallery.refresh();
    }
  });

  /* ---------- search with products and collections ---------- */
  var searchBtn = document.getElementById("searchBtn");
  var searchOverlay = document.getElementById("searchOverlay");
  var searchInput = document.getElementById("searchInput");
  var searchResults = document.getElementById("searchResults");
  var searchClose = document.getElementById("searchClose");
  var searchDebounce;

  function openSearch() {
    if (!searchOverlay) return;

    searchOverlay.classList.add("open");

    setTimeout(function () {
      if (searchInput) {
        searchInput.focus();
      }
    }, 50);
  }

  function closeSearch() {
    if (!searchOverlay) return;

    searchOverlay.classList.remove("open");

    if (searchInput) {
      searchInput.value = "";
    }

    renderSearchResults(
      {
        resources: {
          results: {
            products: [],
            collections: []
          }
        }
      },
      ""
    );
  }

  if (searchBtn) {
    searchBtn.addEventListener("click", openSearch);
  }

  if (searchClose) {
    searchClose.addEventListener("click", closeSearch);
  }

  if (searchOverlay) {
    searchOverlay.addEventListener("click", function (event) {
      if (event.target === searchOverlay) {
        closeSearch();
      }
    });
  }

  function renderSearchResults(data, query) {
    if (!searchResults) return;

    var english = isEnglishLanguage();

    if (!query) {
      searchResults.innerHTML =
        '<p class="search-hint">' +
        (
          english
            ? "Try searching for a brand or category."
            : "Tipp: probier eine Marke oder Kategorie."
        ) +
        "</p>";

      return;
    }

    var results =
      data &&
      data.resources &&
      data.resources.results
        ? data.resources.results
        : {};

    var collections = results.collections || [];
    var products = results.products || [];

    if (collections.length === 0 && products.length === 0) {
      searchResults.innerHTML =
        '<p class="search-hint">' +
        (
          english
            ? "No results for “" + query + "”."
            : "Keine Treffer für „" + query + "“."
        ) +
        "</p>";

      return;
    }

    searchResults.innerHTML = "";

    if (collections.length > 0) {
      var collectionHeading = document.createElement("p");

      collectionHeading.className = "search-section-title";
      collectionHeading.textContent = english
        ? "Collections"
        : "Kategorien";

      searchResults.appendChild(collectionHeading);

      collections.forEach(function (collection) {
        var collectionLink = document.createElement("a");

        collectionLink.className =
          "search-result-item search-collection-result";

        var collectionUrl =
          collection.url ||
          "/collections/" + collection.handle;

        var localizedRoot =
          window.Shopify &&
          window.Shopify.routes &&
          window.Shopify.routes.root
            ? window.Shopify.routes.root
            : "/";

        if (
          localizedRoot !== "/" &&
          localizedRoot !== "" &&
          collectionUrl.indexOf(localizedRoot) !== 0
        ) {
          var cleanRoot = localizedRoot.replace(/\/$/, "");

          collectionUrl =
            cleanRoot +
            (
              collectionUrl.charAt(0) === "/"
                ? collectionUrl
                : "/" + collectionUrl
            );
        }

        collectionLink.href = collectionUrl;

        collectionLink.innerHTML =
          '<div class="sr-info">' +
            "<h5>" +
              (english ? "Collection" : "Kategorie") +
            "</h5>" +
            "<span></span>" +
          "</div>";

        var collectionTitle =
          collectionLink.querySelector(".sr-info span");

        if (collectionTitle) {
          collectionTitle.textContent = collection.title;
        }

        searchResults.appendChild(collectionLink);
      });
    }

    if (products.length > 0) {
      var productHeading = document.createElement("p");

      productHeading.className = "search-section-title";
      productHeading.textContent = english
        ? "Products"
        : "Produkte";

      searchResults.appendChild(productHeading);

      products.forEach(function (product) {
        var productLink = document.createElement("a");

        productLink.className = "search-result-item";
        productLink.href = product.url;

        productLink.innerHTML =
          '<img src="' +
          (
            product.featured_image
              ? product.featured_image.url
              : ""
          ) +
          '" alt="">' +
          '<div class="sr-info">' +
            "<h5></h5>" +
            "<span></span>" +
          "</div>" +
          '<span class="sr-price"></span>';

        var vendorElement =
          productLink.querySelector(".sr-info h5");

        var titleElement =
          productLink.querySelector(".sr-info span");

        var priceElement =
          productLink.querySelector(".sr-price");

        if (vendorElement) {
          vendorElement.textContent = product.vendor || "";
        }

        if (titleElement) {
          titleElement.textContent = product.title || "";
        }

        if (priceElement) {
          priceElement.textContent = product.price || "";
        }

        searchResults.appendChild(productLink);
      });
    }
  }

  if (searchInput) {
    searchInput.addEventListener("input", function () {
      var query = searchInput.value.trim();

      clearTimeout(searchDebounce);

      if (!query) {
        renderSearchResults({}, "");
        return;
      }

      searchDebounce = setTimeout(function () {
        fetch(
          "/search/suggest.json?q=" +
          encodeURIComponent(query) +
          "&resources[type]=product,collection" +
          "&resources[limit]=8" +
          "&resources[options][unavailable_products]=show"
        )
          .then(function (response) {
            return response.json();
          })
          .then(function (data) {
            renderSearchResults(data, query);
          })
          .catch(function () {});
      }, 220);
    });
  }

  document.addEventListener("keydown", function (event) {
    if (qvIsOpen()) {
      if (event.key === "Escape") {
        closeQuickView();
        return;
      }

      var tag = (event.target.tagName || "").toLowerCase();

      if (
        qvGallery &&
        (event.key === "ArrowLeft" || event.key === "ArrowRight") &&
        tag !== "input" &&
        tag !== "textarea" &&
        tag !== "select"
      ) {
        event.preventDefault();
        qvGallery.step(event.key === "ArrowRight" ? 1 : -1);
      }

      return;
    }

    if (event.key === "Escape") {
      if (
        searchOverlay &&
        searchOverlay.classList.contains("open")
      ) {
        closeSearch();
      }

      if (
        cartDrawer &&
        cartDrawer.classList.contains("open")
      ) {
        closeCart();
      }
    }
  });

  /* ---------- category tile filter fallback ---------- */
  document.querySelectorAll(".cat-tile[data-cat]").forEach(function (tile) {
    tile.addEventListener("click", function (event) {
      var cat = tile.dataset.cat;

      var target = document.querySelector(
        '.product[data-category="' + cat + '"]'
      );

      if (
        target &&
        tile.getAttribute("href") === "#"
      ) {
        event.preventDefault();

        var archive = document.getElementById("archive");

        if (archive) {
          archive.scrollIntoView({
            behavior: "smooth"
          });
        }
      }
    });
  });

  refreshCart();
})();
